import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as customerActions from './customer.actions';
import { Customer, CustomerLocation } from '../../shared/models/shared.model';
import { CustomerModuleState } from '../models/customer.model';

export const customerAdapter: EntityAdapter<Customer> = createEntityAdapter<Customer>();
export const initialState = <CustomerModuleState>{
  customers: customerAdapter.getInitialState([]),
  selectedCustomer: null,
  selectedLocation: null,
  searchText: '',
  loadingCustomers: false,
};

const customerReducer = createReducer(
  initialState,
  on(customerActions.getCustomersRequest, (state) => ({
    ...state,
    loadingCustomers: true,
  })),
  on(customerActions.getCustomersSuccess, (state, { customers }) => ({
    ...state,
    customers: customerAdapter.setAll(customers, state.customers),
    loadingCustomers: false,
  })),
  on(customerActions.getCustomersError, (state) => ({
    ...state,
    customers: customerAdapter.removeAll(state.customers),
    loadingCustomers: false,
  })),
  on(customerActions.setSelectedCustomer, (state, { customer }) => ({
    ...state,
    selectedCustomer: customer,
  })),
  on(customerActions.upsertCustomerSuccess, (state, { customer }) => ({
    ...state,
    selectedCustomer: customer,
    customers: customerAdapter.upsertOne(customer, state.customers),
  })),
  on(customerActions.clearCustomers, (state) => ({
    ...state,
    customers: customerAdapter.removeAll(state.customers),
  })),
  on(customerActions.getLocationsRequest, (state) => ({
    ...state,
    loadingLocations: true,
  })),
  on(customerActions.getLocationsSuccess, (state, { locations }) => ({
    ...state,
    selectedCustomer: {
      ...state.selectedCustomer,
      locations,
    },
    loadingLocations: false,
  })),
  on(customerActions.getLocationsError, (state) => ({
    ...state,
    loadingLocations: false,
  })),
  on(customerActions.setSelectedLocation, (state, { locationId }) => {
    const location: CustomerLocation[] =
      state.selectedCustomer && state.selectedCustomer.locations
        ? state.selectedCustomer.locations.filter((l) => l.id === locationId)
        : [];
    return {
      ...state,
      selectedLocation: location.length > 0 ? location[0] : null,
    };
  }),
  on(customerActions.upsertLocationSuccess, (state, { location }) => ({
    ...state,
    selectedLocation: location,
    selectedCustomer: {
      ...state.selectedCustomer,
      locations: state.selectedCustomer.locations
        ? [...state.selectedCustomer.locations, location]
        : [location],
    },
  })),
  on(customerActions.deleteLocationSuccess, (state, { id }) => ({
    ...state,
    selectedCustomer: {
      ...state.selectedCustomer,
      locations: [...state.selectedCustomer.locations.filter((c) => c.id !== id)],
    },
  })),
  on(customerActions.clearSelectedCustomer, (state) => ({
    ...state,
    selectedLocation: null as CustomerLocation,
    selectedCustomer: null as Customer,
  })),
  on(customerActions.searchCustomers, (state, { searchtext }) => ({
    ...state,
    searchText: searchtext,
  })),
);

export function reducer(state: CustomerModuleState | undefined, action: Action) {
  return customerReducer(state, action);
}
